// @flow

const sanitizeParamsForAnalytics = (urlSearchParams: URLSearchParams): string => {
  const encodedSpace = '%20';
  const searchRegExp = new RegExp(/-space-/, 'g');
  const sanitizedParams = urlSearchParams.toString().replace(searchRegExp, encodedSpace);

  return sanitizedParams;
}

const changeWhiteSpacesToSpaceWord = (parameters: string): string => {
  return parameters.replace(/\s/g, '-space-');
}

const decodeAndTrimEndWhitespace = (param: string): string => decodeURI(param).trimEnd();

const normalizeParameters = (parameters: string): string => {
  return parameters.split(":").map(decodeAndTrimEndWhitespace).join(':');
}

const adaptTrackingValue = (categoryData: CategoryData): CategoryData => {
  const [pathname, search] = categoryData.link.split('?');
  const [parameters, hash] = search.split('#');
  const normalizedParameters = normalizeParameters(parameters);
  const urlSearchParams = new URLSearchParams(changeWhiteSpacesToSpaceWord(normalizedParameters));
  const navigationParameter = urlSearchParams.get('nav');

  if (navigationParameter === null) {
    return categoryData;
  }

  const trackingValue = navigationParameter.split(':');
  trackingValue.shift();
  trackingValue.unshift('expmore');

  urlSearchParams.set('nav', trackingValue.join(':'));

  const sanitizedParams = sanitizeParamsForAnalytics(urlSearchParams);
  const link = [pathname, sanitizedParams].filter(Boolean).join('?');

  categoryData.link = [link, hash].filter(Boolean).join('#');

  return categoryData;
};

export const adaptNavigationTrackingValue = (navigationData: SectionData[]): SectionData[] => {
  return navigationData.map((sectionData: SectionData) => {
    sectionData.children = sectionData.children.map(adaptTrackingValue);

    return sectionData;
  });
};
